export default __webpack_public_path__ + "static/top_background-1b9fa09c8e176bd2e7288c66e9e8abeb.png";